import { Logger } from "./utils";

export const globalConfig = {
    abiStoreUrl: 'https://cdn.jsdelivr.net/gh/ujjwalguptaofficial/ethcontracts@main/abi/',
    logger: new Logger()
};